import React from 'react'
import styled, { keyframes } from 'styled-components'
import loadingIcon from 'assets/loading.png'

const Loading = () => {
    return (
        <React.Fragment>
            <Loadingbg></Loadingbg>
            <LoadingWapper>
                <LoadingIcon src={loadingIcon}></LoadingIcon>
                <LoadingText>
                    Loading...
                </LoadingText>
            </LoadingWapper>
        </React.Fragment>
    )
}

const Loadingbg = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background: #000;
    opacity: 20%;
    z-index: 9999;
`

const LoadingWapper = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    border-radius: 24px;
    transform: translate(-145px, -60px);
    width: 290px;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: #fff;
    z-index: 9999;
`
const loadingIconAnimate = keyframes`
   from{
       transform:rotate(0deg)
   }
   to{
       transform:rotate(360deg)
   }
`
const LoadingIcon = styled.img`
    height: 40px;
    width: 40px;
    animation: ${loadingIconAnimate} 2s infinite linear;
`

const LoadingText = styled.div`
    font-size: 16px;
    color: #333333;
`

export default Loading
